import EditablePropsType from '../../../types/composer';

export const mediaSchema = {
  type: EditablePropsType.Object,
  label: 'Media',
  name: 'media',
  properties: {
    src: {
      type: EditablePropsType.Media,
      label: 'Upload Source',
      name: 'src',
      accept: ['image/*', 'video/*'],
    },
    type: {
      type: EditablePropsType.Select,
      label: 'Type',
      name: 'type',
      selectOptions: {
        options: [
          {
            value: 'image',
            label: 'Image',
          },
          {
            value: 'svg',
            label: 'SVG',
          },
          {
            value: 'video',
            label: 'Video',
          },
        ],
      },
    },
    altText: {
      type: EditablePropsType.Text,
      name: 'altText',
      label: 'Alt Text',
    },
    alignment: {
      label: 'Alignment',
      name: 'alignment',
      type: EditablePropsType.Select,
      selectOptions: {
        options: [
          {
            value: 'right',
            label: 'Right',
          },
          {
            value: 'center',
            label: 'Center',
          },
        ],
      },
    },
    controls: {
      label: 'Controls',
      name: 'controls',
      type: EditablePropsType.Boolean,
    },
    autoplay: {
      label: 'Autoplay',
      name: 'autoplay',
      type: EditablePropsType.Boolean,
    },
    loop: {
      label: 'Loop',
      name: 'loop',
      type: EditablePropsType.Boolean,
    },
  },
};

export default mediaSchema;
